import { render, staticRenderFns } from "./SealsLabel.vue?vue&type=template&id=b0fd7606&scoped=true"
import script from "./SealsLabel.vue?vue&type=script&lang=ts"
export * from "./SealsLabel.vue?vue&type=script&lang=ts"
import style0 from "./SealsLabel.vue?vue&type=style&index=0&id=b0fd7606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fd7606",
  null
  
)

export default component.exports